

<mat-accordion class="example-headers-align">
    <mat-expansion-panel hideToggle *ngFor="let item of data">
        <mat-expansion-panel-header (click)="headerToggle(item)">
            <mat-panel-title>
              {{item.title}}
            </mat-panel-title>

        </mat-expansion-panel-header>
        <p class="expansion-text" [innerHTML]="item.body | sanitizeHtml"></p>
    </mat-expansion-panel>

    <!-- <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
        <mat-expansion-panel-header>
            <mat-panel-title>
                מי זכאי לקבל הלוואה?
            </mat-panel-title>

        </mat-expansion-panel-header>
        <p class="expansion-text">
            טקסט על חישוב הריבית. המגיע לו ועל האופן שבו הוא צפוי לעמוד בהתחייבויות הפיננסיות שלו ולמעשה לשלם את החשבונות במלואם ובזמן. עוד טקסט על כיצד הוא משפיע עליי, כיצד ההלוואה שאקח תשפיע על דירוג האשראי שלי. טקסט על חישוב הריבית. המגיע לו ועל האופן שבו הוא צפוי לעמוד בהתחייבויות הפיננסיות שלו ולמעשה לשלם את החשבונות במלואם ובזמן. עוד טקסט על כיצד הוא משפיע עליי, כיצד ההלוואה שאקח תשפיע על דירוג האשראי שלי.
          </p>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" hideToggle>
        <mat-expansion-panel-header>
            <mat-panel-title>
                איך מתבצע ההחזר?
            </mat-panel-title>

        </mat-expansion-panel-header>

        <p class="expansion-text">
            טקסט על חישוב הריבית. המגיע לו ועל האופן שבו הוא צפוי לעמוד בהתחייבויות הפיננסיות שלו ולמעשה לשלם את החשבונות במלואם ובזמן. עוד טקסט על כיצד הוא משפיע עליי, כיצד ההלוואה שאקח תשפיע על דירוג האשראי שלי. טקסט על חישוב הריבית. המגיע לו ועל האופן שבו הוא צפוי לעמוד בהתחייבויות הפיננסיות שלו ולמעשה לשלם את החשבונות במלואם ובזמן. עוד טקסט על כיצד הוא משפיע עליי, כיצד ההלוואה שאקח תשפיע על דירוג האשראי שלי.
          </p>
    </mat-expansion-panel> -->

</mat-accordion>
